import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { navLinks, contactInfo, allCourses } from "../mock";

const LOGO = "/logo-light.webp";

export default function Footer() {
  return (
    <footer className="bg-[#0E2743] text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img src={LOGO} alt="CDL Academy" className="h-16 w-auto mb-5" />
            <p className="text-white/60 text-sm leading-relaxed">
              ELDT theory training built by instructors with over 100 years of
              combined experience — listed as a provider on the FMCSA's Training
              Provider Registry. Drivers build brighter futures.
            </p>
          </div>

          {/* Pages */}
          <div>
            <h4 className="font-head font-semibold uppercase tracking-wider text-white text-sm mb-5">
              Explore
            </h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h4 className="font-head font-semibold uppercase tracking-wider text-white text-sm mb-5">
              Courses
            </h4>
            <ul className="space-y-3">
              {allCourses.map((c) => (
                <li key={c.id}>
                  <Link
                    to="/courses"
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-head font-semibold uppercase tracking-wider text-white text-sm mb-5">
              Get In Touch
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/60">
                <Phone className="w-4 h-4 text-white/80 mt-0.5" />
                <a href={`tel:${contactInfo.phone.replace(/[^0-9]/g, "")}`} className="hover:text-white">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <Mail className="w-4 h-4 text-white/80 mt-0.5" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-white">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <Clock className="w-4 h-4 text-white/80 mt-0.5" />
                {contactInfo.hours}
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <MapPin className="w-4 h-4 text-white/80 mt-0.5" />
                {contactInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} CDL Academy. All rights reserved.
          </p>
          <p className="text-white/40 text-xs">
            Listed on the FMCSA Training Provider Registry • Results reported to the National Registry
          </p>
        </div>
      </div>
    </footer>
  );
}
